import type { Group, RolesOverviewMember } from './types';

/** workspace_admin always has full layer access regardless of any per-layer
 * permission row (enforced server-side) — offering them in an access picker
 * would just be a confusing no-op, so callers filter them out first. */
export function isWorkspaceAdminMember(m: RolesOverviewMember, workspaceId: string | null): boolean {
  if (!workspaceId) return false;
  return m.assignments.some((a) => a.workspace_id === workspaceId && a.role_codes.includes('workspace_admin'));
}

export function isWorkspaceAdminGroup(g: Group, workspaceId: string | null): boolean {
  if (!workspaceId) return false;
  return g.grants.some((gr) => gr.workspace_id === workspaceId && gr.role_code === 'workspace_admin');
}
